import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
import thumbnailsWithBlurSchema from './thumbnailsWithBlurSchema';
const mainHeaderBlockSchema = Joi.object({
  type: Joi.string().valid('mainHeader').required(),
  code: Joi.string().allow('', null).optional(),
  topTitle: Joi.string().allow('', null).optional(),
  title: Joi.string().allow('', null).optional(),
  subtitle: Joi.string().allow('', null).optional(),
  button: Joi.object({
    text: Joi.string().allow('', null),
    link: Joi.string().allow('', null),
    style: Joi.string().allow('', null),
    target: Joi.string().valid('_self', '_blank').allow(null)
  }).allow(null).unknown(true),
  backgroundImage: mediaUrlSchema.allow(null).optional(),
  thumbnail: mediaUrlSchema.allow(null).optional(),
  thumbnailsWithBlur: thumbnailsWithBlurSchema.allow(null).optional(),
  backgroundVideo: mediaUrlSchema.allow(null).optional(),
  backgroundColor: Joi.string().allow('', null).optional(),
  products: Joi.array().items(Joi.object({
    id: Joi.number().required(),
    name: Joi.string().required()
  }).unknown(true)).allow(null).empty(true)
}).unknown(true);
export default mainHeaderBlockSchema;